import AvailabilityCalendar from 'component/calendar/Calendar'
import DialogWindow from 'component/material/DialogWindow'
import GridContainer from 'component/material/GridContainer'
import GridItem from 'component/material/GridItem'
import Loader from 'component/material/Loader'
import {LANGUAGE_LIST} from 'helper/constants'
import ChangeMyPasswordDialog from 'layout/PrivateLayout/ChangeMyPasswordDialog'
import privateLayoutStyle from 'layout/PrivateLayout/privateLayoutStyle'
import PropTypes from 'prop-types'
import React, {useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import {logout} from 'redux/action/authAction'
import {updateGlobalSettings} from 'redux/action/globalSettingsAction'
import Cfs from 'style/asset/cfs.png'
import {ReactComponent as LKQ} from 'style/asset/lkq.svg'
import {ReactComponent as Dots} from 'style/asset/menu-dots.svg'
import {Trans} from '@lingui/macro'
import {Select} from '@material-ui/core'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import withStyles from '@material-ui/core/styles/withStyles'
import DateRangeIcon from '@material-ui/icons/DateRange'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined'

const PrivateLayoutTopBar = (props) => {
  const {classes, currentUser, logout, loading, updateGlobalSettings, currentLanguage} = props

  const [anchorEl, setAnchorEl] = useState(null)
  const [openChangePassword, setOpenChangePassword] = useState(false)

  const [openCalendar, setOpenCalendar] = useState(false)

  const handleOpenCalendar = () => {
    setOpenCalendar(true)
  }

  const handleCloseCalendar = () => {
    setOpenCalendar(false)
  }

  const handleOpenChangePassword = () => {
    setOpenChangePassword(true)
  }

  const handleCloseChangePassword = () => {
    setOpenChangePassword(false)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    return logout()
  }

  const handleChangeLanguage = (lang) => {
    updateGlobalSettings({currentLanguage: lang})
  }

  return (
    <>
      <GridContainer justifyContent={'space-between'} className={classes.topBar}>
        <GridItem xs={7} container direction={'row'}>
          <div className={classes.topBarLKQ}>
            <LKQ />
          </div>
          <div className={classes.topBarElit}>
            <img src={Cfs} alt={'cfs'} />
          </div>
        </GridItem>
        <GridItem
          container
          xs={5}
          className={classes.userMenu}
          justifyContent={'flex-end'}
          alignItems={'center'}
        >
          <GridItem className={classes.calendarTopBar}>
            <DateRangeIcon onClick={handleOpenCalendar} />
            {/* CALENDAR DIALOG */}
            <DialogWindow
              title={<Trans>Setting unavailability of supplier</Trans>}
              fullWidth={false}
              open={openCalendar}
              onClose={handleCloseCalendar}
            >
              <AvailabilityCalendar onClose={handleCloseCalendar} />
            </DialogWindow>
          </GridItem>

          <GridItem className={classes.userName}>
            {loading ? <Loader className={classes.nameLoader} /> : currentUser?.name}
          </GridItem>
          <GridItem className={classes.languageSelectContainer}>
            <Select
              value={currentLanguage}
              onChange={(e) => handleChangeLanguage(e.target.value)}
              className={classes.languageSelect}
              autoWidth={true}
            >
              {LANGUAGE_LIST.map((country, index) => (
                <MenuItem value={country.value} key={index} className={classes.languageSelectItem}>
                  {country.icon}
                </MenuItem>
              ))}
            </Select>
          </GridItem>
          <GridItem className={classes.svgDots} onClick={handleClick}>
            <Dots />
          </GridItem>
        </GridItem>
      </GridContainer>

      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        className={classes.dropDownMenu}
      >
        <MenuItem className={classes.dropDownMenuItem} onClick={handleOpenChangePassword}>
          <VpnKeyOutlinedIcon />
          <Trans>Change password</Trans>
        </MenuItem>
        <MenuItem className={classes.dropDownMenuItem} onClick={handleLogout}>
          <ExitToAppIcon />
          <Trans>Logout</Trans>
        </MenuItem>
      </Menu>

      <ChangeMyPasswordDialog
        onClose={handleCloseChangePassword}
        handleCloseMenu={handleClose}
        open={openChangePassword}
      />
    </>
  )
}

PrivateLayoutTopBar.propTypes = {
  classes: PropTypes.object,
  currentUser: PropTypes.object,
  logout: PropTypes.func,
  updateGlobalSettings: PropTypes.func,
  loading: PropTypes.bool,
  currentLanguage: PropTypes.string,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logout,
      updateGlobalSettings,
    },
    dispatch
  )
}

export default compose(
  withStyles(privateLayoutStyle),
  connect((store) => {
    return {
      currentLanguage: store.globalSettings.currentLanguage,
    }
  }, mapDispatchToProps)
)(PrivateLayoutTopBar)
